import Header from "./Header";
import Footer from "./Footer";
import {TranslationProvider} from "../contexts/TranslationContext";

const Layout = ({ children }) => {
  return (
    <TranslationProvider>
      <Header />
      <main className={'pt-[86px] sm:pt-[80px]'}>
        {children}
      </main>
      <Footer/>
    </TranslationProvider>
  );
};

export default Layout;